// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5015": "59cf926dd644","6955": "3c78411cb82e","8438": "8c0cc16437b1","8858": "74c484eacc2f",}[chunkId] + ".css"
}